"use strict";
var SpriteText2D_1 = require("./SpriteText2D");
exports.SpriteText2D = SpriteText2D_1.SpriteText2D;
var MeshText2D_1 = require("./MeshText2D");
exports.MeshText2D = MeshText2D_1.MeshText2D;
var utils_1 = require("./utils");
exports.textAlign = utils_1.textAlign;



//////////////////
// WEBPACK FOOTER
// ./~/three-text2d/lib/index.js
// module id = 3
// module chunks = 0